import { observer } from 'mobx-react-lite'

import { Flag } from '@src/app/feature-flags'
import type { PhoneMenuSelection } from '@src/service/voice/ActiveCall'

import IncomingCallInvitationText from './IncomingCallInvitationText'
import IncomingCallPhoneMenuBadge from './IncomingCallPhoneMenuBadge'
import type IncomingCallUiStore from './IncomingCallUiStore'

interface IncomingCallDescriptionProps {
  uiStore: IncomingCallUiStore
  phoneMenuSelection?: PhoneMenuSelection | null
}

function IncomingCallDescription({
  phoneMenuSelection,
  uiStore,
}: IncomingCallDescriptionProps) {
  if (!phoneMenuSelection) {
    return (
      <IncomingCallInvitationText invitation={uiStore.invitation} via={uiStore.via} />
    )
  }

  return (
    <Flag
      flag="webPhoneMenuInsights"
      fallback={
        <IncomingCallInvitationText invitation={uiStore.invitation} via={uiStore.via} />
      }
    >
      <IncomingCallPhoneMenuBadge phoneMenuSelection={phoneMenuSelection} />
    </Flag>
  )
}

export default observer(IncomingCallDescription)
